export default __webpack_public_path__ + "static/char-s-13-cht-f76c29fd1ca0d49f2e9d7b1a22bafec0.png";